// src/components/commonfunctions/handleInputChange.ts

export const debounceRef: { current: NodeJS.Timeout | null } = { current: null };

export const handleInputChange = (
  field: 'email_address' | 'password',
  value: string,
  handleDispatch: (field: 'email_address' | 'password', value: string) => void,
  handleInputError: (field: 'email_address' | 'password', value: string) => void
) => {
  // Clear the previous timeout if any
  if (debounceRef.current) {
    clearTimeout(debounceRef.current);
  }
  handleInputError(field, value)
  // Set a new timeout to dispatch the updateField after 500ms delay
  debounceRef.current = setTimeout(() => {
    handleDispatch(field, value);
  }, 500); // Adjust debounce delay (500ms) as needed

};
